import React from "react";
import { Alert } from "react-bootstrap";
import "./DashboardComponents.css";

// Phase 5, §35. Renders backend-supplied data-quality/legacy warnings
// verbatim — never hidden, never summarized away. Each warning is
// { code, count?, message }.
export default function DataQualityNotice({ warnings }) {
  if (!warnings || warnings.length === 0) return null;

  return (
    <Alert variant="warning" className="perf-data-quality">
      <div className="perf-data-quality-title">
        <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
        Data quality notice
      </div>
      <ul className="perf-data-quality-list">
        {warnings.map((w, i) => (
          <li key={`${w.code}-${i}`}>
            {w.message}
            {w.count != null && ` (${w.count} record${w.count === 1 ? "" : "s"})`}
          </li>
        ))}
      </ul>
    </Alert>
  );
}
